import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale("es");

const reporteDePagosAgrupadosPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if(values.bancos !== 0 && values.bancos && values.bancos.length > 0){
        let textoFiltrado = ''
        values.bancos.map((valueBanco) => {
            textoFiltrado += `${valueBanco.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Bancos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    // Agrupar pagos por forma de pago
    const pagosAgrupados = values.pagos.reduce((grupos, pago) => {
        const formaDePago = pago.formaDePago || 'Sin especificar';
        if (!grupos[formaDePago]) {
            grupos[formaDePago] = [];
        }
        grupos[formaDePago].push(pago);
        return grupos;
    }, {});

    let pagos = []
    let totalGeneral = 0;

    // Construir la tabla con pagos agrupados
    Object.keys(pagosAgrupados).forEach(formaDePago => {
        const pagosPorForma = pagosAgrupados[formaDePago];
        
        // Ordenar los pagos por fecha dentro de cada grupo
        pagosPorForma.sort((a, b) => {
            const fechaA = moment(a.fechaPago, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY']);
            const fechaB = moment(b.fechaPago, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY']);
            return fechaA.isBefore(fechaB) ? -1 : fechaA.isAfter(fechaB) ? 1 : 0;
        });
        
        let subtotal = 0;

        // Encabezado del grupo
        pagos.push([
            { text: `FORMA DE PAGO: ${formaDePago}`, style: 'clienteTabla', alignment: 'center', colSpan: 9, fillColor: '#e6f3ff' },
            {}, {}, {}, {}, {}, {}, {}, {}
        ]);

        // Pagos del grupo (ya ordenados por fecha)
        pagosPorForma.forEach(valuePago => {
            pagos.push([
                {text: valuePago.banco, style: 'textoTabla', alignment: 'left'}, 
                {text: valuePago.fechaPago, style: 'textoTabla', alignment: 'center'}, 
                {text: valuePago.proveedor, style: 'textoTabla', alignment: 'left'},
                {text: valuePago.factura, style: 'textoTabla', alignment: 'left'},
                {text: valuePago.proyecto, style: 'textoTabla', alignment: 'left'},
                {text: valuePago.formaDePago, style: 'textoTabla', alignment: 'left'},
                {text: valuePago.moneda, style: 'textoTabla', alignment: 'center'},
                {text: dineroDisabledMask(valuePago.monto), style: 'textoTabla', alignment: 'right'},
                {text: valuePago.referencia, style: 'textoTabla', alignment: 'left'},
            ]);
            subtotal += parseFloat(valuePago.monto || 0);
        });

        // Subtotal del grupo
        pagos.push([
            { text: `Subtotal ${formaDePago}:`, style: 'textoTabla', alignment: 'right', colSpan: 7, fillColor: '#f0f8ff' },
            {}, {}, {}, {}, {}, {},
            { text: dineroDisabledMask(subtotal), style: 'textoTabla', alignment: 'right', fillColor: '#f0f8ff' },
            { text: '', style: 'textoTabla', fillColor: '#f0f8ff' },
        ]);

        totalGeneral += subtotal;

        // Línea separadora entre grupos
        pagos.push([
            { text: '', style: 'textoTabla', colSpan: 9, border: [false, false, false, true], borderColor: ['', '', '', '#666666'] },
            {}, {}, {}, {}, {}, {}, {}, {}
        ]);
    });

    // Total general
    pagos.push([
        { text: 'TOTAL GENERAL:', style: 'tituloTabla', alignment: 'right', colSpan: 7, border: [true, true, true, true], fillColor: '#cccccc' },
        {}, {}, {}, {}, {}, {},
        { text: dineroDisabledMask(totalGeneral), style: 'tituloTabla', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'textoTabla', border: [false, true, true, true], fillColor: '#cccccc' },
    ]);
      

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: function(currentPage, pageCount) {
            return {
                margin: [0, 0, 0, 0],
                image: 'logoBiwo', 
                alignment: 'center', 
                width: 80
            };
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              {
      //							rowSpan: 3,
                                  border: [false, false, false, false],
                                  image: 'logo',
                                  fit: [80, 80] 
                                  //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                              },
                              {
                              //	rowSpan: 2,
                                  border: [false, false, false, false],
                                  table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                        [
                                            { 
                                            text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                            style: "tableHeader" 
                                            }
                                        ],
                                        [
                                          {
                                            text: "R.F.C: "+empresa.rfc,
                                            style: "textoChico",
                                            alignment: "center",
                                          },
                                        ],
                                        [
                                            {
                                              text: empresa.calle+' '+
                                                    empresa.numeroCalle+' '+
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                        [
                                            {
                                              text: empresa.colonia.tipoAsentamiento+' '+
                                              empresa.colonia.nombre+' C.P. '+
                                              empresa.colonia.cp+' '+
                                              empresa.municipio.nombre+' '+
                                              empresa.estado.abreviatura+' '+
                                              empresa.pais.abreviatura+' '
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                          [{text: 'REPORTE DE PAGOS AGRUPADOS', style: 'tableHeader'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                          ]
      
                      ]
                  },
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                                          defaultBorder: false,
                                      },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
                  
              },
              
              {
                  style: 'tableExample',
                  table: {
                      widths: ['12%', '10%', '14%', '14%', '12%', '12%', '6%', '10%', '10%'],
                      layout: {
                          defaultBorder: true,
                      },
                      body: [
                          [
                            {text: 'Banco', style: 'tituloTabla'},		              
                            {text: 'Fecha', style: 'tituloTabla'},
                            {text: 'Proveedor', style: 'tituloTabla'},
                            {text: 'Factura', style: 'tituloTabla'},
                            {text: 'Proyecto', style: 'tituloTabla'},
                            {text: 'Forma De Pago', style: 'tituloTabla'},
                            {text: 'Moneda', style: 'tituloTabla'},
                            {text: 'Monto', style: 'tituloTabla'},
                            {text: 'Referencia', style: 'tituloTabla'},
                          ],
                          //Falta esto en el backend y ya
                          ...pagos
                      ]
                  },
                  layout: {
                      fillColor: (rowIndex, node, columnIndex) => {
                          // Conservar colores especiales para encabezados de grupo y subtotales
                          if (node.table.body[rowIndex] && node.table.body[rowIndex][0] && node.table.body[rowIndex][0].fillColor) {
                              return node.table.body[rowIndex][0].fillColor;
                          }
                          return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                      },
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
              },
              
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              grupoHeader: {
                  fontSize: 9,
                  bold: true,
                  color: '#0066cc'
              },
              subtotalTabla: {
                  fontSize: 8,
                  bold: true,
                  color: '#0066cc'
              },
              clienteTabla: {
                fontSize: 10,
                bold: true,
                italics: false,
                fillColor: '#ecfdfe',
            }
          },
          pageSize: 'LETTER',
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};

export default reporteDePagosAgrupadosPdf;